export const googleMapAPIKey = 'AIzaSyBlMjmRld1x1capi7RMPnN-58i5JoQYcNk';